import { PriceListsFilterApiDto } from '@lx/shared/api/models';

export const PriceListAreaEnum = PriceListsFilterApiDto.AreaEnum;
export type PriceListArea = PriceListsFilterApiDto.AreaEnum;
